import PropTypes from 'prop-types'
import { property, noop, values } from 'lodash'
import { RULE_TYPES, RULE_BEHAVIORS } from '../constants'

const rulePropTypes = {
  type: PropTypes.oneOf(values(RULE_TYPES)).required,
  behavior: PropTypes.oneOf(values(RULE_BEHAVIORS)).required,
  message: PropTypes.string.required,
  ruleOption: PropTypes.string
}

const fieldPropTypes = {
  number: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isCaching: PropTypes.bool,
  withTranslate: PropTypes.bool,
  translateOptions: PropTypes.bool,
  required: PropTypes.bool,
  rules: PropTypes.arrayOf(PropTypes.shape(rulePropTypes))
}

const formPropTypes = {
  ContainerComponent: PropTypes.func.isRequired,
  form: PropTypes.shape({
    fields: PropTypes.arrayOf(PropTypes.shape(fieldPropTypes)).isRequired,
    number: PropTypes.number.isRequired,
    autocomplete: PropTypes.bool,
    action: PropTypes.string,
    method: PropTypes.string
  }).isRequired,
  action: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  initialValues: PropTypes.objectOf(PropTypes.string),
  additionalValues: PropTypes.objectOf(PropTypes.string),
  fieldComponents: PropTypes.object.isRequired,
  onValidateFieldAsync: PropTypes.func.isRequired
}

const formDefaultProps = {
  onSubmit: noop,
  onError: noop,
  initialValues: {},
  additionalValues: {}
}

const formInitialState = {
  fields: {},
  isLoading: true,
  cachedValues: {},
  globalErrors: []
}

const formFieldsPropTypes = {
  onFocusField: PropTypes.func.isRequired,
  onBlurField: PropTypes.func.isRequired,
  onDisableField: PropTypes.func.isRequired,
  onEnableField: PropTypes.func.isRequired,
  onSetFieldErrors: PropTypes.func.isRequired,
  onSetFieldValue: PropTypes.func.isRequired,
  onSetGlobalErrors: PropTypes.func.isRequired,
  onSetIsLoading: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fields: PropTypes.objectOf(PropTypes.shape(fieldPropTypes)).isRequired,
  globalErrors: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  ContainerComponent: PropTypes.func.isRequired,
  fieldComponents: PropTypes.object.isRequired
}

const formFieldsDefaultProps = {
  ContainerComponent: property('children')
}

const formFieldPropTypes = {
  field: PropTypes.shape(fieldPropTypes).isRequired,
  onFocusField: PropTypes.func.isRequired,
  onBlurField: PropTypes.func.isRequired,
  onDisableField: PropTypes.func.isRequired,
  onEnableField: PropTypes.func.isRequired,
  onSetFieldValue: PropTypes.func.isRequired
}

export {
  formFieldPropTypes,
  formFieldsDefaultProps,
  formFieldsPropTypes,
  fieldPropTypes,
  rulePropTypes,
  formPropTypes,
  formDefaultProps,
  formInitialState
}
